
import { Line , Bar} from 'vue-chartjs'
import { Component, Mixins, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class LineChart extends Mixins(Line) {
    @Prop({default: null})
    chartdata!: object

    @Prop({default: null})
    options!: object

    mounted () {
        this.renderChart(this.chartdata, this.options)
    }
}

